import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import {
//   fetchDoorHandles,
//   fetchGroupDoor,
// } from '../../../store/actions/door.handle.action';
import CardProduct from '../../card/CardProduct/CardProduct';
import LeftMenuDesign from '../../common/LeftMenuDesign/LeftMenuDesign';
import { CabinetEditorContext } from '../CabinetEditor/CabinetEditor';
import './LeftDoorCustomDesignMenu.scss';
import { useTranslation } from 'react-i18next';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import Chip from '../../common/Chip/Chip';

const LeftDoorCustomDesignMenu = ({
  open,
  onDragStart,
  productType,
  beveledDoor,
  groupDoorId,
  setBeveledDoor,
  setGroupDoorId,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { door, groupDoor } = useSelector(state => state.doorAndHandle || {});

  // useEffect(() => {
  //   if (!productType || !groupDoorId) return;
  //   dispatch(
  //     fetchDoorHandles({
  //       product_type: productType,
  //       door_type: 'HINGED',
  //       group_type: groupDoorId,
  //     })
  //   );
  // }, [groupDoorId, productType]);

  return (
    <LeftMenuDesign
      open={open}
      classNames={{ root: '!left-[72px] relative', content: '!p-0 gap-0' }}
      header={<span className="text-title-large text-nowrap">{t('Door')}</span>}
      content={
        <>
          <div className="flex items-center justify-start self-stretch relative top-0 left-0 right-0 px-16 py-8 bg-fills-white">
            <div className="flex items-start gap-8 self-stretch">
              {groupDoor.data?.map(item => (
                <Chip
                  label={
                    <span className="text-label-medium-emphasized">
                      {item.label}
                    </span>
                  }
                  active={item.value === groupDoorId}
                  onClick={() => setGroupDoorId(item.value)}
                />
              ))}
            </div>
          </div>
          <div className="grid grid-cols-2 p-8 items-start align-content-start gap-2 self-stretch">
            {/* {(show45 === true */}
            {(beveledDoor === true
              ? door?.data?.door_without_handle
              : door?.data?.door_with_handle
            )?.map((md, i) => {
              const name = getValueFromString(md.name);
              const description = getValueFromString(md.description ?? '');

              return (
                <CardProduct
                  key={i}
                  md={md}
                  title={name}
                  description1={description}
                  description2={md.size}
                  moduleType={i}
                  onDragStart={onDragStart}
                />
              );
            })}
          </div>
        </>
      }
    />
  );
};

export default LeftDoorCustomDesignMenu;
